"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var Indicator = function Indicator(props) {
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "row form-group"
  }, (0, _preact.h)("label", null, "Helpfulness indicator"), (0, _preact.h)("p", null, "Show percentage of users that found this helpful. Note: this will only show a % after 5 votes have been submitted"), (0, _preact.h)("div", {
    className: "col-md-12"
  }, (0, _preact.h)(_Switcher.default, {
    on: props.status,
    onChange: props.setIndicator
  }))), Boolean(props.status) && (0, _preact.h)("div", {
    className: "row topic-helpfulness-indicator_percentage_label"
  }, (0, _preact.h)("span", {
    className: "topic-helpfulness-indicator_percentage"
  }, "80%"), (0, _preact.h)("span", {
    className: "topic-helpfulness-indicator_percentage_label_input"
  }, (0, _preact.h)(_InputGroup.default, {
    id: "helpfulness-indicator",
    title: "Helpfulness indicator label",
    meta: "The message that shows how many users found this topic helpful",
    type: "text",
    onChange: function onChange(e) {
      return props.setIndicatorLabel('indicatorLabel', e.target.value);
    },
    value: props.indicatorLabel
  }))));
};

var _default = Indicator;
exports.default = _default;